import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import { generateLinksFrom } from "@tCooneyBrothers/Overrides/Components/PageBreadcrumbs";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const { pathname } = getLocation(state);

    return {
        breadcrumbLinks: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        currentPage: getCurrentPage(state).type,
        pathname,
    };
};

type Props = HasHistory & WidgetProps & ReturnType<typeof mapStateToProps> & HasCategoryContext;

const CategoryImage: React.FunctionComponent<Props> = ({
    category,
    breadcrumbLinks,
    linksState,
    nodeId,
    currentPage,
    pathname,
}: Props) => {
    const getBrandFromPathname = (pathname: string) => {
        const segments = pathname.split("/").filter(Boolean);
        return segments[0] === "brands" && segments.length >= 2 ? segments[1] : null;
    };

    const formatBrandName = (slug: string) => slug.replace(/-/g, " ").replace(/\b\w/g, char => char.toUpperCase());

    const cleanBrandName = (brandName: string) => brandName.replace(/[™®©℠]/g, "").trim();

    const links = breadcrumbLinks || generateLinksFrom(linksState, nodeId);

    const breadcrumbCategoryTitle =
        breadcrumbLinks?.[breadcrumbLinks.length - 1]?.children ??
        generateLinksFrom(linksState, nodeId).slice(-1)[0]?.children;

    const isBrandShopAllProducts = links[1]?.children === "brands" && links[3]?.children === "Shop All Products";

    const baseTitle = category?.shortDescription ?? breadcrumbCategoryTitle;

    let finalTitle = baseTitle;

    if (
        currentPage === "CategoryDetailsPage" &&
        pathname.includes("/brands/") &&
        !isBrandShopAllProducts &&
        typeof baseTitle === "string"
    ) {
        const brandSlug = getBrandFromPathname(pathname);

        if (brandSlug) {
            const breadcrumbBrandName = links[2]?.children;

            const brandName =
                typeof breadcrumbBrandName === "string"
                    ? cleanBrandName(breadcrumbBrandName)
                    : formatBrandName(brandSlug);

            if (brandName && !baseTitle.startsWith(brandName)) {
                finalTitle = `${brandName} ${baseTitle}`;
            }
        }
    }

    return (
        <Typography variant="h1" size="32px" data-test-selector="categoryTitle">
            {isBrandShopAllProducts && !category ? <>{links[2]?.children}</> : (finalTitle as any)}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(connect(mapStateToProps, undefined)(CategoryImage)),
    definition: {
        group: "Categories",
        icon: "PageTitle",
    },
};

export default widgetModule;
